/* istanbul ignore file */
const triggerEventOnElement = (el: HTMLElement | null, eventType = 'change') => {
    const evt = document.createEvent('Event');

    evt.initEvent(eventType, true, true);
    (el as EventTarget).dispatchEvent(evt);
};

const updateHiddenField = (
    inputId: string,
    inputValue = '',
    eventType = 'change',
) => {
    const input = document.getElementById(inputId) as HTMLInputElement | null;

    if (!input) {
        const bodyDom = document.getElementsByTagName('body');
        const hiddenInput = document.createElement('input');

        hiddenInput.type = 'hidden';
        hiddenInput.id = inputId;
        hiddenInput.name = inputId;
        hiddenInput.value = inputValue;

        if (bodyDom && bodyDom[0]) {
            bodyDom[0].appendChild(hiddenInput);
            triggerEventOnElement(hiddenInput, eventType);
        }
    } else {
        input.value = inputValue;
        triggerEventOnElement(input, eventType);
    }
};

export default updateHiddenField;
